export default "__VITE_ASSET__CX73hMn3__"